import logEventGoogleAnalyticsUtil from 'modules/google-analytics/utils/log-event'

export function logEventAnalyticsUtil (eventAction, eventData) {
  return logEventGoogleAnalyticsUtil(eventAction, eventData)
}

export default logEventAnalyticsUtil
